import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    margin-top: 2px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n    width: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Checkbox } from '../../Checkbox';
import { TableCell } from '../TableCell';
import { TABLE_CHECKBOX_CELL_WIDTH } from './constants';
import { getPropsBlocker } from '../../../utils';
export var TableCheckboxCellRoot = styled(TableCell).withConfig(getPropsBlocker({}, false))(_templateObject(), TABLE_CHECKBOX_CELL_WIDTH);
export var TableCheckboxCellCheckbox = styled(Checkbox).withConfig(getPropsBlocker({}, false))(_templateObject2());